<template>
  <div class="lock-page">
    <app-navbar></app-navbar>
    <div class="wrapper wrapper-full-page">
      <div class="full-page lock-page section-image" filter-color="black">
        <!--   you can change the color of the filter page using: data-color="blue | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
            <div class="col-lg-4 col-md-6 ml-auto mr-auto">
              <card type="lock" class="text-center pb-2">
                <img
                  slot="header"
                  src="static/img/central-gym150x150.webp" 
                  alt="CentralGym logo"
                />
                <h4 class="card-title">{{ this.username }}</h4>
                <p>¿Deseas cerrar sesión?</p>
                <p-button
                  @click="logout"
                  class="mr-2"
                  slot="footer"
                  type="default"
                  round
                  outline
                >
                  Cerrar Sesion
                </p-button>
                <p-button
                  @click="cancel"
                  slot="footer"
                  type="default"
                  round
                  outline
                >
                  Cancelar
                </p-button>
              </card>
            </div>
          </div>
        </div>
        <app-footer></app-footer>
        <div
          class="full-page-background"
          style="background-image: url(static/img/background/bruno-abatti.jpg)"
        ></div>
      </div>
    </div>
  </div>
</template>
<script>
import AppNavbar from "./Layout/AppNavbar";
import AppFooter from "./Layout/AppFooter";
import { Card, Button, FgInput } from "src/components/UIComponents";
import axios from "axios"

export default {
  components: {
    Card,
    AppNavbar,
    AppFooter,
    FgInput,
    [Button.name]: Button,
  },
  methods: {
    toggleNavbar() {
      document.body.classList.toggle("nav-open");
    },
    closeMenu() {
      document.body.classList.remove("nav-open");
      document.body.classList.remove("off-canvas-sidebar");
    },
    logout() {
      sessionStorage.clear()
      this.$router.push("/login")
    },
    cancel(){
      this.$router.push("/")
    }
  },
  data() {
    return {
      form: {
        password: "",
      },
      username: sessionStorage.getItem('WHbUjdv3TG') || "No User"
    };
  },
  mounted(){
    this.$swal.close()
  },
  beforeDestroy() {
    this.closeMenu();
  },
};
</script>
<style></style>
